<template>
  <lr-link
    :to="courseData.url"
    target="_blank"
    class="video-course"
    @mouseover="mouseover"
    @mouseleave="mouseleave"
    @click="(e) => handleClick(e, courseData)"
  >
    <div class="video-course-mask" v-show="showMask">
      <img src="~/assets/image/icon/play.svg" alt="" />
    </div>
    <div class="video-course-item">
      <div class="item-post">
        <img class="item-post-image" :src="bgImg" alt="" />
        <h3
          class="item-post-title ellipsis-2"
          v-html="videoTitle"
          :style="{ 'text-align': textAlign }"
        ></h3>
      </div>
      <div class="item-detail">
        <span class="play-cnt">
          <img
            class="play-cnt-img"
            src="~/assets/image/icon/playCnt.svg"
            alt=""
          />
          {{ courseData.post_hits || courseData.total_post_hits }}
        </span>
        <span class="play-duration">{{ videoTime }}</span>
        <slot></slot>
      </div>
    </div>
  </lr-link>
</template>

<script>
import {
  getmmss,
  getCourseBackgroundTitle,
  getCourseBackgroundType,
  getCourseBackgroundUrl,
  jpkUrlHandler,
  gethhmmss
} from '@/common/utils';

export default {
  name: 'videoCourse',
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    useImgUrl: {
      // 兼容部分图片地址直接拼接好
      type: Boolean,
      default: false,
    },
    textAlign: {
      type: String,
      default: 'start',
    },
  },
  data() {
    return {
      showMask: false,
    };
  },
  computed: {
    courseData() {
      const {
        background = {},
        total_time,
        post_hits,
        url,
        total_post_hits,
        status,
      } = this.data;
      const { image, title } = background;
      return {
        total_time,
        post_hits,
        url,
        image,
        title,
        total_post_hits,
        status,
      };
    },

    // 复刻学院原有逻辑
    coverImg() {
      return getCourseBackgroundType(this.data);
    },

    // 展示的背景图
    bgImg() {
      const { coverImg } = this;
      const imgFormat = /.(png|jpg|gif|jpeg|webp)$/;
      return this.useImgUrl || imgFormat.test(coverImg)
        ? coverImg
        : getCourseBackgroundUrl(coverImg);
    },

    // 处理标题的展示内容
    videoTitle() {
      return getCourseBackgroundTitle(this.data);
    },

    // 展示的视频时长
    videoTime() {
      const { data } = this;
      if (data.total_time_second || data.time_second) return gethhmmss(data.total_time_second || data.time_second);
      if (data.total_time) return data.total_time;
      if (data.time) return data.time;
      if (data.post_video && data.post_video.time) {
        return getmmss(data.post_video.time);
      }
      return '';
    },

    // 视频跳转的链接
    videoHrefObj() {
      const { data } = this;
      let url = '';
      let target = '_blank';

      if (data.status === 0) {
        url = 'javascript:;';
        target = '_self';
      } else if (data.url) {
        if (data.url.includes('//edu.wps.cn')) {
          url = jpkUrlHandler(data.url, 'wps_xy_pagetab');
        } else {
          url = data.url;
        }
      } else if (data.post_id || data.id) {
        url = `/learning/course/detail/id/${data.post_id || data.id}`;
      }

      return { url, target };
    },
  },
  methods: {
    handleClick(e, courseData) {
      this.$emit('click', courseData);
      if (this.data.status === 0) {
        e.preventDefault();
        this.$toast(
          '该教程已经下架，请浏览其他教程',
          'iconic_search_cancel',
          2000
        );
        return;
      }
    },
    renderPostTitle(title) {
      return title ? title.replace(' ', '<br/>') : '';
    },
    mouseover(e) {
      this.showMask = true;
      this.$emit('mouseover', e);
    },
    mouseleave(e) {
      this.showMask = false;
      this.$emit('mouseleave', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-course {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  transition: background-color 0.2s linear;

  &:hover {
    background-color: rgba(8, 48, 93, 0.04);
    border-radius: 12px;
  }

  &:active:not(:disabled) {
    background-color: rgba(8, 48, 93, 0.08);
    border-radius: 12px;
  }

  &-mask {
    position: absolute;
    left: 50%;
    top: 12px;
    transform: translateX(-50%);
    width: 222px;
    height: 125px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    z-index: 5;
    cursor: pointer;

    img {
      width: 30px;
      height: 39px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) scale(1.5);
      z-index: 6;
    }
  }

  &-item {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 12px 12px 4px 12px;

    .item-post {
      position: relative;

      &-image {
        width: 222px;
        height: 125px;
        border-radius: 8px;
        cursor: pointer;
      }
      &-title {
        max-width: 176px;
        color: #ffffff;
        position: absolute;
        left: 23px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        font-weight: bold;
        line-height: 25px;
      }
    }

    .item-detail {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #8c939f;
      line-height: 32px;

      .play-cnt {
        @include flex-align-center();
        .play-cnt-img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
